module.exports = {"532523101":"玉屏镇","532523102":"新现镇","532523103":"和平镇","532523104":"白河镇","532523204":"白云乡","532523205":"新华乡","532523206":"湾塘乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/532523.json
// module id = 2764
// module chunks = 0